import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import BasicInformation from './BasicInformation';
import EmergencyContacts from './EmergencyContacts';
import SSN from './SSN';
import GenderIdentity from './GenderIdentity';
import PermissionSplash from 'components/PermissionSplash';

export default class Personal extends React.Component {
	render() {
		let routeProps = this.props;
			const read = this.props.userRole !== undefined ? this.props.userRole.some(role => {
				return (role.section === 'Personal' && role.access_read === "1")
			}) : false
		if ((this.props.variant === 'admin' && read === true) || this.props.variant !== 'admin') {
			return (
				<Switch>
					<Route path="/portal/personal/Basic Information" render={() => <BasicInformation {...routeProps} />} />
					<Route path="/portal/personal/Emergency Contacts" render={() => <EmergencyContacts {...routeProps} />} />
					<Route path="/portal/personal/SSN" render={() => <SSN {...routeProps} />} />
					<Route path="/portal/personal/Gender Identity" render={() => <GenderIdentity {...routeProps} />} />
					<Route path="*" render={() => (
						<Redirect to="/portal/personal/Basic Information" />
					)} />
				</Switch>
			);
		} else {
			return (

				<PermissionSplash />

			);
		}
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/Personal/index.jsx